import 'regenerator-runtime/runtime'
import amazingScroll from './modules/amazingScroll'
import amazingScrollSlider from './modules/amazingScrollSlider'
import magnificPopupTranslation from './modules/magnificPopupTranslation'
import scrollToElement from './modules/scrollToElement'
import fixedNavbar from './modules/fixedNavbar'
import TabHandler from './modules/tabHandler'
import "magnific-popup"

var animationList = {
	'fade-top': 'top:-100px->0; transition:all 0s->all 1s; opacity:0->1;',
	'fade-right': 'opacity: 0->1; right:-500px->0; transition:all 0s->all 1s',
	'fade-bottom': 'bottom:-100px->0; transition:all 1s; opacity:0->1;',
	'fade-left': 'opacity: 0->1; left:-500px->0; transition:all 0s->all 1s',
	'fade-left-slider': 'opacity: 0->.46; left:-500px->0; transition:all 0s->all 1s',
	'fade-left-top': 'opacity: 0->1; left:-50px->0; top:-50px->0; transition:all 0s->all 1s',
	'fade-left-bottom': 'opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1s',
	'opacity': 'opacity: 0->1; transition:all 0s->all 1s',
	'enlarge': 'transform:scale(0.5)->scale(1); opacity: 0->1; transition:all 0s->all 1s',
	'shrink': 'transform:scale(1)->scale(0.5); opacity: 0->1; transition:all 0s->all 1s',
	'rotate': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1s'
}
document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth >= 1200) {
		window.animate = amazingScroll({
			start: {
				visibleAfterLoading: true,
				waitForScroll: {
					on: false,
					ratio: 0
				}
			},
			animation: animationList
		})
	}
	const selectors = ['.slidersukcesu']
	selectors.forEach(selector => {
		amazingScrollSlider(selector, animationList)
		jQuery(selector).carousel({
			interval: 10000, // dlugosc filmu
			pause: false
		})
	})


	if (!Array.prototype.findIndex) {
		Object.defineProperty(Array.prototype, 'findIndex', {
			value: function (predicate) {
				if (this == null) {
					throw new TypeError('"this" ma wartość null lub undefined');
				}
				var o = Object(this);
				var len = o.length >>> 0;
				if (typeof predicate !== 'function') {
					throw new TypeError('predykat musi być funkcją');
				}
				var thisArg = arguments[1];
				var k = 0;
				while (k < len) {
					var kValue = o[k];
					if (predicate.call(thisArg, kValue, k, o)) {
						return k;
					}
					k++;
				}
				return -1;
			}
		});
	}
	if (document.querySelector('#find-product-for-you')) {
		const tabNav = [...document.querySelectorAll('.tab__nav-item .tab__nav-link')];
		const tabContent = [...document.querySelectorAll('#product-tab .tab-pane.fade')];
		const leftArrow = [...document.querySelectorAll('.tab__arrow--left')];
		const rightArrow = [...document.querySelectorAll('.tab__arrow--right')];
		const tabHandler = new TabHandler(tabNav, tabContent, leftArrow, rightArrow);
		tabHandler.init();
	}

	magnificPopupTranslation()
	if (window.innerWidth >= 1200) {
		scrollToElement(document.querySelector('nav.navbar').offsetHeight)
	} else {
		scrollToElement()
	}

	fixedNavbar()

	let galleryItem = document.querySelector('.gallery-animation');
	if (galleryItem) {
		$('.gallery-animation').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		})
	}


	const body = document.querySelector('body');
	setTimeout(() => body.style.paddingBottom = "0px", 500);
	// window.slider = new imageSlider('querySelector', 2000)
})

// Wyłączanie linków - usunąć przed zakończeniem prac nad stroną

// document.addEventListener('DOMContentLoaded', function () {
// 	[...document.querySelectorAll('a:not([href*="#"])')]
// 		.filter(e => !e.classList.contains('our-projects__item'))
// 		.forEach(el => el.setAttribute('href', '#!'))
// })



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js